export const MAX_FILE_SIZE_MB = 5;
export const MAX_BREADCRUMBS_SIZE = 3;
export const CURRENCYVSSYMBOLMAP: { [key: string]: string } = {
  USD: '$',
  INR: '₹',
  AED: 'د.إ'
};

export const DASHBOARD_URL: { [key: string]: string } = {
  'ad-details': 'ancillaryAdDetails',
  'payment-breakdown': 'ancillaryPaymentBreakdown',
  'payment-status': 'ancillaryPaymentStatus',
  'user-profile': 'profile',
  verification: 'verification',
  newVerification: 'newVerification',
  'request-correction': 'requestCorrection',
  'appeal-request': 'appealRequest',
  'verification-details': 'verificationDetails',
  'manage-account': 'manageAccount',
  home: 'home',
  'account-option': 'account',
  'notification-category': 'notificationPreferences',
  email: 'email',
  sms: 'sms',
  pushNotification: 'pushNotification',
  transactions: 'transactions',
  services: 'services',
  category: 'services',
  'pricing-estimate': 'pricingDetails',
  'document-upload': 'documentUpload',
  'additional-components': 'documentUpload',
  'letter-of-auth': 'letterOfAuth',
  overview: 'documentUpload',
  'pricing-details': 'paymentDetails',
  'find-report': 'findReport',
  'fetch-report-details': 'findReport',
  'report-document-details': 'findReport',
  'existing-reports': 'findReport',
  'verify-report-details': 'findReport',
  'verification-insufficiency': 'insufficiency',
  'language-preference': 'languagePreference',
  vault: 'vault',
  'subscription-payment': 'subscription-payment',
  status: 'status',
  'validate-trueproof': 'validateTrueproof',
  'client-requirement-list-tab': 'applicationDetails',
  'select-issuers': 'selectIssuers',
  'select-documents': 'selectDocuments'
};

export const ATTRIBUTE_TYPE_KEY = 'AttributeType';

export const REDIRECT_TO_HOME_DELAY_TIME = 2 * 1000;

export const AVAILABLE_KEY = 'Available';

export const TRUE = 'true';

/**
 * Trusted domains that are allowed for redirects
 * Supports subdomains (e.g., app.dataflowgroup.com, custom.preprod.dataflowgroup.com)
 * Payment gateways: PayPal, N-Genius (Network International)
 * Authentication: UAE Pass (UAE government digital identity)
 */
export const TRUSTED_REDIRECT_DOMAINS = [
  'dataflowgroup.com',
  // Payment gateway domains
  'paypal.com', // PayPal payment gateway (includes www.paypal.com, checkout.paypal.com, etc.)
  'ngenius-payments.com', // N-Genius payment gateway (Network International)
  // Authentication domains
  'uaepass.ae', // UAE Pass - UAE government digital identity service,
  'dataflowstatus.com', // Dataflowstatus - Dataflowgroup's status page
  // Development domains
  'localhost'
];
